import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11304d84"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cookie-consent"
}
const _hoisted_2 = { class: "cookie-consent__inner" }
const _hoisted_3 = { class: "cookie-consent__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_ctx.isVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, [
                _createTextVNode(" Мы используем файлы cookie и сервис «Яндекс.Метрика» для сбора обезличенных данных, чтобы сделать сайт удобнее. Продолжая работу с сайтом, вы соглашаетесь с нашей "),
                _createVNode(_component_router_link, {
                  to: "/privacy-policy",
                  target: "_blank",
                  class: "cookie-consent__link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Политикой конфиденциальности")
                  ]),
                  _: 1
                }),
                _createTextVNode(". ")
              ]),
              _createVNode(_component_AppButton, {
                theme: "dark",
                class: "cookie-consent__btn",
                onClick: _ctx.accept
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Согласен ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}